var signOutConfirmationTemplate = require('templates/signOutConfirmation.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  
  type: 'signOutConfirmation',
  template: {
    'signOutConfirmation': signOutConfirmationTemplate
  },
  bindEvents: function() {
  }
});
